export default [
  {
    path: '/traductions-automatiques',
    name: 'autoTranslationBatchList',
    component: () => import('@/views/AutoTranslation/List.vue'),
    meta: {
      layout: 'content'
    }
  },
  {
    path: '/traductions-automatiques/batches/:batchId',
    name: 'autoTranslationBatchDetails',
    component: () => import('@/views/AutoTranslation/Details.vue'),
    meta: {
      layout: 'content'
    }
  }
]
